var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input-qr-scan-model',{ref:"codeRef",attrs:{"label":"Tracking"},on:{"keyupEnter":_vm.scanInput},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }